import Vue from "vue";
import loading from "./loading.vue";// 引入loading实例
const Mask = Vue.extend(loading); // 返回loadingService服务状态的实例 Loading.service()方式调用 
export default  (function () {
    let Service = function () {
        var div; var loadingMask;
        this.service = function () {
            div = document.createElement("div");
            let child = document.createElement("div");
            div.appendChild(child); document.body.appendChild(div);
            this.loadingMask = new Mask();
            this.loadingMask.visible = true;
            this.loadingMask.$mount(child);
        };
        this.close = function () {
            this.loadingMask.visible = false;
            try{
                document.body.removeChild(div);
            }catch(e){

            }
        };
    }; 
    return new Service();
})();



// WEBPACK FOOTER //
// ./src/serve/Loading/index.js